export default __webpack_public_path__ + "static/media/tech-1-fig3.fb969c8d.png";